import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "theme";

function readInitialTheme() {
  // The inline script in public/index.html has already resolved and applied
  // the theme before paint, so trust the attribute it set.
  if (typeof document !== "undefined") {
    const applied = document.documentElement.getAttribute("data-theme");
    if (applied === "light" || applied === "dark") {
      return applied;
    }
  }
  return "dark";
}

/**
 * Reads and toggles the colour theme, keeping the `data-theme` attribute on
 * <html> and localStorage in sync.
 */
export function useTheme() {
  const [theme, setTheme] = useState(readInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {
      // Storage can be unavailable (private mode, blocked cookies).
      // The theme still applies for this session, so this is non-fatal.
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((current) => (current === "dark" ? "light" : "dark"));
  }, []);

  return { theme, toggleTheme };
}
